<template>
  <div>
    <!-- loader -->
    <!-- <div class="loader-wrapper">
      <div id="loader">
        <div id="shadow"></div>
        <div id="box"></div>
      </div>
    </div> -->
    <!-- loader end -->

   
    <!-- home section -->
    <section class="img-scence-bg home">
      <div class="animation-circle-inverse">
        <i></i>
        <i></i>
        <i></i>
      </div>
      <div class="animation-circle-inverse absolute">
        <i></i>
        <i></i>
        <i></i>
      </div>
      <div class="container">
        <div class="menu">
          <router-link to="/menu5">    <img 
                  src="../assets/images/menu.png"
                  alt="top5"
                  class="img-fluid"
                  style="width: 100px;"
                /></router-link>
              </div>
              <div class="menu-back">
                <a @click="playsound();$router.go(-1);">
<img
                  src="../assets/images/menu-back.png"
                  alt="top5"
                  class="img-fluid"
                  style="width: 80px;"
                />
</a>
              </div>
              <div class="menu-next">
                <router-link to="/menu5-images-scence-q">
                <img @click="playsound"
                  src="../assets/images/menu-next.png"
                  alt="top5"
                  class="img-fluid"
                  style="width: 80px;"
                />
                </router-link>
              </div>
        <div class="row justify-content-center">
        
    
          <div class="col-md-10">
            <div class="home-img-scence">
              <h2 class="text-center">ฉากภาพ สันติภาพและความขัดแย้ง</h2>
              <inner-image-zoom src="../img-scence5.jpg" zoomSrc="../img-scence5.jpg" />

            </div>
          </div>
         
         
        </div>
      </div>
      
    </section>
    <!-- home section end -->

  
    <!--Footer Section End-->
  </div>
</template>
<script>
import InnerImageZoom from 'vue-inner-image-zoom';
import 'vue-inner-image-zoom/lib/vue-inner-image-zoom.css';
import $ from "jquery";
export default {
  components: {
    'inner-image-zoom': InnerImageZoom
  },
  data() {
    return {
      responsiveNav: false,
      responsiveOthePageslist: false,
      responsiveBlogList: false,
    };
  },
  mounted() {
   // this.loader();
  },
  methods: {
    playsound(){
      var audio = new Audio('./click.mp3');
				audio.play();
    },
    loader() {
      $(document).ready(function () {
        $(window).on("load", function () {
          $(".loader-wrapper").fadeOut("slow");
          $(".loader-wrapper").remove("slow");
        });
      });
    },
    toggleNavbar(toToggle) {
      if (toToggle === "navbar") {
        this.responsiveNav = !this.responsiveNav;
      } else if (toToggle === "blogList") {
        this.responsiveBlogList = !this.responsiveBlogList;
      } else if (toToggle === "otherPagesList") {
        this.responsiveOthePageslist = !this.responsiveOthePageslist;
      }
    },
  },
  beforeCreate: function () {
    document.body.className = "landing-page";
  },
};
</script>
<style scoped>
.navbar {
  position: absolute;
}
</style>
